import { useAppSelector } from "@sso/hooks/useRedux";
import { selectPricingQuery } from "@sso/store/slices/pricing";

import { usePricingsQuery } from "..";

export const useGetPricingsQuery = () => {
  const queryParams = useAppSelector(selectPricingQuery);
  return usePricingsQuery(queryParams);
};
